import { IonIcon, IonToast, withIonLifeCycle } from '@ionic/react';
import { chatbubble, chatbubbleEllipses, logoAppleAppstore, logoFacebook, logoGooglePlaystore, logoInstagram, logoTwitter, logoWhatsapp, mail, mailOpen, share } from 'ionicons/icons';
import React from 'react';
import '../styles/ContactUs.scss';
import Utilities from '../Utilities';
import { Share } from '@capacitor/share';
import { Clipboard } from '@capacitor/clipboard';

class ContactUs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            message: null
        }
    }

    render() {
        return (
            <div className="contact-us">
                <p id="p">{window.ln.contactUsTitle}</p>
                <div className="options">
                    <button onClick={() => { 
                        Utilities.trackEvent("Contact", "Contact by Email", "Contact Us");
                        window.open("mailto:hello@chillnstudy.com?subject=[App:FMS]");
                    }} >
                        <div className='circle blue-circle'>
                            <IonIcon icon={mailOpen} />
                        </div>
                        <span>{window.ln.emailUs}</span>
                    </button>
                    <button onClick={() => {
                        Utilities.trackEvent("Contact", "Contact by WhatsApp", "Contact Us")
                        window.open("https://wa.me/36705359591?text=[App:FMS]")
                    }} >
                        <div className='circle blue-circle'>
                            <IonIcon className="guide" data-guide-contact="1" icon={chatbubbleEllipses} />
                        </div>
                        <span>{window.ln.whatsappUs}</span>
                    </button>
                    { (window.os !== "android") &&
                        <button className="guide" data-guide-rate="1" onClick={() => {
                            Utilities.trackEvent("Rate", "Open AppStore", "Contact Us")
                            window.open("https://itunes.apple.com/gb/app/id1496147001")
                        }}>
                            <div className='circle blue-circle'>
                                <IonIcon icon={logoAppleAppstore} />
                            </div>
                            <span>{window.ln.rateAppStore}</span>
                        </button>
                    }
                    { (window.os === "android") &&
                        <button className="guide" data-guide-rate="1" onClick={() => {
                            Utilities.trackEvent("Rate", "Open Google Play", "Contact Us")
                            window.open("https://play.google.com/store/apps/details?id=com.dominikgyecsek.simplecards")
                        }}>
                            <div className='circle blue-circle'>
                                <IonIcon icon={logoGooglePlaystore} />
                            </div>
                            <span>{window.ln.rateGoogle}</span>
                        </button>
                    }
                    <button onClick={ async () => {

                        Utilities.trackEvent("Share", "Recommend App", "Contact Us")

                        if (window.os === "web") {

                            Clipboard.write({
                                string: 'I have been using the Flashcards made Simple app to study anything, anytime, anywhere, anyhow. https://flashcardsmadesimple.com'
                            });

                            setTimeout(() => {
                                window.toast(window.ln.copied);
                            }, 200)

                        } else {

                            let shareRet = await Share.share({
                                title: "Flashcards made Simple",
                                text: 'I have been using the Flashcards made Simple app to study anything, anytime, anywhere, anyhow. https://flashcardsmadesimple.com',
                                url: "https://flashcardsmadesimple.com",
                                dialogTitle: 'I have been using the Flashcards made Simple app to study anything, anytime, anywhere, anyhow. https://flashcardsmadesimple.com',
                            });

                        }

                    }}>
                        <div className='circle blue-circle'>
                            <IonIcon icon={share} />
                        </div>
                        <span>{window.ln.shareFriends}</span>
                    </button>
                </div>
                <IonToast
                    isOpen={this.state.message !== null}
                    onDidDismiss={() => { this.setState({ message: null }) }}
                    message={this.state.message}
                    position="top"
                    duration={2000}
                    buttons={[ { text: window.ln.close } ]} 
                    color="dark"
                />
            </div>
        );
    }

};


export default withIonLifeCycle(ContactUs);
